module.exports = __webpack_public_path__ + "images/tour-3d-10515a39f2bc6ffe6a891ed691a82f10.svg";